import { AfterViewInit, Component, computed, ElementRef, inject, Injector, signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonButtonRowWidget, CommonForm, CommonTextField, CommonTextFieldConfig, CommonTextFieldWidget } from "@eforall/common";
import { DashboardDialogFramePart, DialogContext } from '@eforall/dashboard';
import { DialogMode } from '@interfaces';
import { FuncService } from '../../../../../services';
import { GoalCommentEditorDialogData } from '../goal-dialog-data';


@Component({
	selector: 'goal-comment-editor-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		CommonTextFieldWidget,
		CommonButtonRowWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './comment-editor.dialog.html'
})

export class GoalCommentEditorDialog implements AfterViewInit {

	public dialogRef = inject(MatDialogRef<GoalCommentEditorDialog>);
	private dialogContext: DialogContext<GoalCommentEditorDialogData> = inject(MAT_DIALOG_DATA);
	private func = inject(FuncService);

	public readonly form = new CommonForm<{ comment: string }>(inject(Injector));
	public commentEditorBtn = viewChild.required<ElementRef<HTMLButtonElement>>('commentEditorBtn');

	public readonly addOrEditTitle = computed(() => {
		return this.dialogContext.data?.mode == DialogMode.ADD ? 'Add Goal Comment' : 'Edit Goal Comment';
	});

	public readonly buttonText = computed(() => {
		return this.dialogContext.data?.mode == DialogMode.ADD ? 'Add' : 'Save';
	});

	ngAfterViewInit() {
		this.form.setSubmitButton(this.commentEditorBtn(), async (values: { comment: string }, changed: string[]) => {
			await this.saveOrAddComment(values.comment);
		});
	}

	async saveOrAddComment(comment: string) {
		const data = this.dialogContext.data;
		if (data) {
			if (data.mode == DialogMode.ADD) {
				await this.func.accGoal.addComment({ accGoalId: data.accGoalId, comment });
			} else {
				await this.func.accGoal.editComment({ accGoalCommentId: data.accGoalCommentId, comment });
			}
			this.dialogRef.close();
		}
	}

	//
	// Form Fields
	//
	readonly comment = computed<CommonTextField>(() => ({
		config: signal<CommonTextFieldConfig>({
			label: 'Comment',
			isRequired: true,
			min: 1,
			max: 2000,
			fixCase: 'sentence-case',
			multiLine: true,
		}),
		formFieldName: 'comment',
		form: this.form,
		actualValue: computed(() => this.dialogContext.data?.mode == DialogMode.EDIT ? this.dialogContext.data?.comment : ''),
		pendingValue: signal<string | null>(null),
		saving: signal(false),
		error: signal(''),
	}));
}